/**
 * @todo: Candidate for including to a shared library.
 */
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
/**
 * Merges class names using tailwind-merge and classnames libraries.
 */
const mergeClassNames = (...classes) => twMerge(classNames(...classes));
export default mergeClassNames;
